import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { E5ConfigurationService } from 'e5core-angular-services';
import { WorkItemModel } from '../../models/work-item';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-casenotes',
  template: `
  <span *ngIf="workItem$" [ngSwitch]="style.current()">
    <e5core-ui-work-casenotes-box *ngSwitchCase='0' [workItem$]='workItem$' [readonly]='readonly' [pagesizes]='pagesizes'></e5core-ui-work-casenotes-box>
    <e5core-ui-work-casenotes-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [readonly]='readonly' [pagesizes]='pagesizes'></e5core-ui-work-casenotes-bootstrap>
    <e5core-ui-work-casenotes-material *ngSwitchCase='2' [workItem$]='workItem$' [readonly]='readonly' [pagesizes]='pagesizes'></e5core-ui-work-casenotes-material>
  </span>
  <div *ngIf="!(workItem$)" class="e5core-component-error">&lt;e5core-ui-work-casenotes&gt; [workItem$] must have a BehaviorSubject&lt;WorkItemModel&gt;</div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkCasenotesComponent implements OnInit {

  @Input() workItem$ : BehaviorSubject<WorkItemModel> ;
  @Input() readonly : boolean ;
  @Input() pagesizes : number[] ;
  workId : string ;

  constructor(public style:UiStyleService, private configuration:E5ConfigurationService) { }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-casenotes [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    this.workItem$.subscribe(
      w => {
        if( this.workId != w.workId) {
          this.updateData() ;
        }
      }
    )
  }

  private updateData():void {
  }

}
